import { render, staticRenderFns } from "./interact.vue?vue&type=template&id=323914b8&"
import script from "./interact.vue?vue&type=script&lang=js&"
export * from "./interact.vue?vue&type=script&lang=js&"
import style0 from "./interact.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports